import { getOrganizationsList } from './organizationsApi';
import { Organization } from 'components/common/ObjectTypes';
import { filter_page_size, page_size, SessionExpiredError } from 'api/apiUtils';

export const loadOrganizations = async (
  keycloak_token: string,
  page_offset: number,
  orgSearchInput: string,
  organizations: Organization[],
  org_table_page?: boolean,
): Promise<[Organization[], number, Error | null]> => {
  let total_orgs = 0;
  try {
    const limit = org_table_page ? page_size : filter_page_size;
    const query = {
      limit: limit,
      offset: page_offset,
      search: orgSearchInput,
      ordering: 'name',
      previous:
        process.env.REACT_APP_BASE_URL_LOCAL +
        '/v2/organizations/?pager=limit&limit=' +
        limit +
        '&offset=' +
        (page_offset - limit),
      next:
        process.env.REACT_APP_BASE_URL_LOCAL +
        '/v2/organizations/?pager=limit&limit=' +
        limit +
        '&offset=' +
        (page_offset + limit),
    };
    const temp = await getOrganizationsList(keycloak_token, query);
    // Session expired: say so rather than failing on the missing page.
    if (temp === undefined) return [[], 0, new SessionExpiredError()];
    const new_array: Organization[] = org_table_page
      ? temp.results
      : organizations.concat(temp.results);
    const duplicates_removed: Organization[] = Array.from(
      new Set(new_array.map((obj) => obj.id)),
    ).map((id) => {
      return new_array.find((obj) => obj.id === id)!;
    });
    const alphabetized = duplicates_removed.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    // The total matches the search, so the Workspaces table can page through results.
    total_orgs = temp.count;
    return [alphabetized, total_orgs, null];
  } catch (err: any) {
    console.log(err);
    return [[], 0, err];
  }
};
